var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.947,5.013C18.74,4.407,18.169,4,17.529,4H6.471C5.831,4,5.26,4.407,5.053,5.013L3,11v8c0,0.552,0.448,1,1,1h1 c0.552,0,1-0.448,1-1v-1h12v1c0,0.552,0.448,1,1,1h1c0.552,0,1-0.448,1-1v-8L18.947,5.013z M6.829,6h10.343l1.371,4H5.457L6.829,6z M6.5,15C5.672,15,5,14.328,5,13.5S5.672,12,6.5,12S8,12.672,8,13.5S7.328,15,6.5,15z M17.5,15c-0.828,0-1.5-0.672-1.5-1.5 s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S18.328,15,17.5,15z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.613f7aad094972c664763a08c63b2e4c.svg";
export { ForwardRef as ReactComponent };